let cartArray = [];
const emptyMessage = document.querySelector("[data-part-cart-empty-message]");
const storefrontToken = "8b85c6b44eb757696a41191a6f8b2b9e";
const storefrontUrl = "https://www.kidkraft.com/api/2025-01/graphql.json";
let cartElement = document.querySelector('cart-form');  
class BatchCodeSetup {
  constructor() {
      // if(document.querySelectorAll("[data-btn-type]").length > 0){
      //     document.querySelectorAll("[data-btn-type]").forEach(btn => {
      //         btn.addEventListener("click", (e) => {
              
      //             const btnType = btn.dataset.btnType;
      //                 this._batchCodeSetup(event ,btnType);
      //             });
      //         });
      // };

      if(document.querySelectorAll("[data-validate-batch-code]").length > 0){
          document.querySelectorAll("[data-validate-batch-code]").forEach(btn => {
              btn.addEventListener("click", (event) => {
                  event.preventDefault();
                this.validateBatchCode(event);
              });
          });
      };

      const storedData = JSON.parse(localStorage.getItem("partData"));
      if(localStorage.getItem("warranty") && localStorage.getItem("partData")){
        this.setUpImage(storedData);
        this.setupBanner(storedData);
      }

      if(document.querySelector("#part-checkout-btn")){
        document.querySelector("#part-checkout-btn").addEventListener("click", (e) => {
          e.preventDefault();
          this.addToCart(e);
        });
      }

  };
  
  async setupBanner(data){
    let productId = data.data.productId;
    
    // First get the current product to access its metafields
    const currentProductData = await this.getMainProductData(productId);
    
    // Check if main_product metafield exists
    const mainProductMetafield = currentProductData.metafields?.find(
      metafield => metafield.key === 'main_product'
    );

     let mainProductData;
     if (mainProductMetafield && mainProductMetafield.value) {
       // Parse the main product ID from metafield (handle GID format)
       let mainProductId;
       
       if (mainProductMetafield.value.includes('gid://shopify/Product/')) {
         // Extract ID from GID format: "gid://shopify/Product/8760104550616"
         mainProductId = parseInt(mainProductMetafield.value.split('/').pop());
       } else {
         // Direct numeric ID
         mainProductId = parseInt(mainProductMetafield.value);
       }

       mainProductData = await this.getProductData(mainProductId);
    } else {
      // Fallback to current product if no main_product metafield
      mainProductData = currentProductData;
    }
    
    // Check if mainProductData is valid
    if (!mainProductData || !mainProductData.title) {
      console.error("Main product data not found, using grouped product name as fallback");
      
      // Use grouped product name as fallback
      const groupedProductName = currentProductData?.title || "Product";
      
      // Set fallback data
      const fallbackData = {
        title: groupedProductName,
        images: currentProductData?.images || { edges: [] },
        variants: currentProductData?.variants || { edges: [] }
      };
      
      mainProductData = fallbackData;
    }
    
    const { title, images, variants } = mainProductData;
    
    // Safe image extraction with fallback
    let src = null;
    let altText = title || "Product Image";
    
    if (images && images.edges && images.edges.length > 0) {
      src = images.edges[0].node.src;
      altText = images.edges[0].node.altText || altText;
    }
    
    // Get the first variant's SKU and barcode
    const firstVariant = variants.edges[0]?.node;
    const sku = firstVariant?.sku || '';
    const barcode = firstVariant?.barcode || '';
  
    // Add null check for product title element
    const productTitleElement = document.querySelector("[data-product-title]");
    if (productTitleElement) {
      productTitleElement.textContent = title;
    } else {
      console.warn("Product title element not found in DOM");
    }

    // Replace the placeholder div with an actual image (with small delay to show loading)
    const imageContainer = document.querySelector("[data-product-image]");
    if (imageContainer) {
        if (src) {
            imageContainer.outerHTML = `<img src="${src}" data-product-image class="mx-auto d-block mb-3 mb-sm-0" width="100" height="100" alt="${altText}" title="${altText}" loading="lazy"/>`;
        } else {
            // Show placeholder if no image available
            imageContainer.outerHTML = `<div data-product-image class="mx-auto d-block mb-3 mb-sm-0 d-flex align-items-center justify-content-center bg-light" style="width: 100px; height: 100px; border: 1px solid #ddd;"><span class="text-muted small">No Image</span></div>`;
        }
    } else {
      console.warn("Product image container not found in DOM");
    }
    
    // Update SKU and barcode
    const skuElement = document.querySelector("[data-product-sku]");
    const barcodeElement = document.querySelector("[data-product-barcode]");
    
    if (skuElement) {
      skuElement.textContent = sku;
    } else {
      console.warn("Product SKU element not found in DOM");
    }
    
    if (barcodeElement) {
      barcodeElement.textContent = barcode;
    } else {
      console.warn("Product barcode element not found in DOM");
    }
  }

  _batchCodeSetup(event ,btnType){
      if(btnType == "Replacement Parts"){
        event.preventDefault();
          document.querySelector("[data-warranty-info-content]").classList.add("d-none");
          document.querySelector("[data-batch-code-content]").classList.remove("d-none");
      }else{

      }
  };

  validateBatchCode(event){
      event.preventDefault();
      const batchCodeInput = document.querySelector("[data-batch-code-input]");
      const otherFormField = document.querySelectorAll("[data-other-form-field]");
      const batchCode = batchCodeInput.value;
      const otherFormFields = Array.from(otherFormField).map(field => field.value);
      
      // Check if all required fields are filled
      const allFields = [batchCode, ...otherFormFields];
      const emptyFields = allFields.filter(field => field.trim() === "");
      
      if(emptyFields.length > 0){
          window.notificationEle.updateNotification(
              "Validation Error",
              "Please fill in all required fields",
              { type: "error", timeout: 5000 }
          );
          return;
      }
      
      if(batchCode != "" && otherFormFields.length == 3){
          this._batchCodeValidation(batchCode);
      }
  };

  _batchCodeValidation(batchCode) {
    // --- Input validation ---
    if (typeof batchCode !== "string" || batchCode.trim().length === 0) {
        window.notificationEle.updateNotification(
            "Batch Code Validation",
            "Batch code cannot be empty",
            { type: "error", timeout: 5000 }
        );
        return;
    }

    // Example: Only allow alphanumeric batch codes of length 4–20
    const batchCodePattern = /^[A-Za-z0-9]{4,20}$/;
    if (!batchCodePattern.test(batchCode.trim())) {
        window.notificationEle.updateNotification(
            "Batch Code Validation",
            "Invalid batch code format",
            { type: "error", timeout: 5000 }
        );
        return;
    }

    // --- API request ---
    fetch("/apps/zip-code-validator/api/parts-details", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ batchId: batchCode.trim() })
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
          console.log(data?.status , data?.parts)
            if (data?.status == true && data?.data?.partsJson != null) {
                try {
                    localStorage.setItem("partData", JSON.stringify(data));
                    localStorage.setItem("warranty", "false"); // Store as string for consistency
                } catch (storageError) {
                    console.error("LocalStorage error:", storageError);
                    window.notificationEle.updateNotification(
                        "Batch Code Validation",
                        "Unable to save data locally",
                        { type: "error", timeout: 5000 }
                    );
                    return;
                }
                window.location.href = "/pages/parts-portal";
            } else {
                window.notificationEle.updateNotification(
                    "Batch Code Validation",
                    "Please enter a valid batch code",
                    { type: "error", timeout: 5000 }
                );
            }
        })
        .catch(error => {
            console.error("Fetch error:", error);
            window.notificationEle.updateNotification(
                "Batch Code Validation",
                "Unable to validate batch code. Please try again later.",
                { type: "error", timeout: 5000 }
            );
        });
  };
  
  async setUpImage(data) {
    if (!data?.data?.partsJson?.parts?.length || !data?.data?.productId) {
        console.error("Invalid part data:", data);
        return;
    }

    const partMap = data.data.partsJson.parts;
    const productId = data.data.productId;
    const container = document.querySelector("[data-part-mapper-container]");

    if (!container) {
        console.error("Parts mapper container not found.");
        return;
    }

    // Fetch product data from Storefront API
    let productData;
    let imageMapUrl;
    
    try {
        productData = await this.getProductData(productId);
        console.log(productData)
        if (productData && productData.images && productData.images.edges.length > 0) {
            imageMapUrl = productData.images.edges[0].node.src;
        } else {
            console.warn("No product images found, falling back to partsMap if available");
            imageMapUrl = data.data.partsMap || null;
        }
    } catch (error) {
        console.error("Error fetching product data:", error);
        // Fallback to partsMap if Storefront API fails
        imageMapUrl = data.data.partsMap || null;
    }

    if (!imageMapUrl) {
        console.error("No image URL available from either Storefront API or partsMap");
        return;
    }

    // --- Helper: create element with attributes ---
    const createEl = (tag, attrs = {}, children = []) => {
        const el = document.createElement(tag);
        Object.entries(attrs).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                if (key in el) {
                    el[key] = value; // Direct property (e.g. el.src)
                } else {
                    el.setAttribute(key, value); // Regular attribute
                }
            }
        });
        children.forEach(child => el.appendChild(child));
        return el;
    };

    // --- Create main elements ---
    const img = createEl("img", {
        id: "partsmapper-product-image",
        className: "gallery-image visible",
        src: imageMapUrl,
        alt: "part-image",
        title: "part-image",
        useMap: "#partsmapper-image-map"
    });

    const hiddenInput = createEl("input", {
        type: "hidden",
        name: "test_image",
        value: imageMapUrl
    });

    const map = createEl("map", {
        id: "partsmapper-image-map",
        name: "partsmapper-image-map"
    });

    // --- Add <area> elements ---
    partMap.forEach(part => {
        if (!part?.coords || !part?.sku || !part?.variant_id) return;

        map.appendChild(
            createEl("area", {
                shape: part.shape || "rect",
                href: "#",
                coords: part.coords,
                "data-sku": part.sku,
                variant_id: part.variant_id,
                variant_limit: part.variant_limit ?? ""
            })
        );
    });

    // --- Create wrapper div to match original structure ---
    const wrapper = createEl("div", {
        className: "product-image-gallery"
    });
    
    // --- Add elements to wrapper ---
    wrapper.appendChild(img);
    wrapper.appendChild(hiddenInput);
    wrapper.appendChild(map);
    
    // --- Render wrapper into container ---
    container.replaceChildren(wrapper);


    // --- Bind interactivity ---
    this.mapClickHandler();

  };

  // New method to handle Safari image loading issues
  initializeMapsterWhenReady(img) {
    const self = this;
    
    // Function to initialize mapster
    const initMapster = () => {
      // Small delay for Safari to ensure image is fully rendered
      setTimeout(() => {
        self.mapClickHandler();
      }, 100);
    };

    // Check if image is already loaded
    if (img.complete && img.naturalHeight !== 0) {
      initMapster();
    } else {
      // Wait for image to load
      img.addEventListener('load', initMapster);
      
      // Fallback in case load event doesn't fire (cached images)
      setTimeout(() => {
        if (img.complete && img.naturalHeight !== 0) {
          initMapster();
        }
      }, 200);
    }
  };

  mapClickHandler() {
    const self = this;
    const $image = $("#partsmapper-product-image");

    if ($image.length === 0) {
        console.error("Parts mapper image not found for mapster initialization.");
        return;
    }
    // --- Initialize mapster with Safari-specific configuration ---
    $image.mapster({
        mapKey: "variant_id",
        limit: "variant_limit",
        fill: true,
        fillColor: "000000",
        fillOpacity: 0.1,
        stroke: true,
        strokeColor: "337ab7",
        strokeOpacity: 1,
        strokeWidth: 1,
        fade: true,
        singleSelect: true,
        // Safari fix: ensure proper initialization
        onConfigured: function() {
            // Additional delay for Safari to ensure proper rendering
            setTimeout(() => {
                const img = document.getElementById('partsmapper-product-image');
                if (img && img.naturalWidth > 0) {
                    // Use the current displayed size, not natural size
                    const currentWidth = $image.width();
                    const currentHeight = $image.height();
                    if (currentWidth && currentHeight) {
                        $image.mapster("resize", currentWidth, currentHeight, 0);
                    }
                }
            }, 50);
        },
        onClick: function (e) {
            const variantId = e.key;
            if (!variantId) {
                console.warn("Clicked area has no variant_id.");
                return;
            }

            const areaElement = $(`area[variant_id="${variantId}"]`);
            if (areaElement.length === 0) {
                console.warn(`No <area> element found for variant_id: ${variantId}`);
                return;
            }

            const limit = areaElement[0].getAttribute("variant_limit") || "";
            self.checkVariantAvailability(variantId, limit);
            
            // Scroll to cart section on mobile devices
            // self.scrollToCartSection();
        }
    });

    // --- Resize mapster to current image dimensions ---
    const currentWidth = $image.width();
    const currentHeight = $image.height();
    if (currentWidth && currentHeight) {
      $image.mapster("resize", currentWidth, currentHeight, 1000);
    }

    // // Add window resize handler for Safari compatibility
    // let resizeTimeout;
    // $(window).on('resize', function() {
    //     clearTimeout(resizeTimeout);
    //     resizeTimeout = setTimeout(function() {
    //         const img = document.getElementById('partsmapper-product-image');
    //         if (img && img.naturalWidth > 0 && $image.mapster('get')) {
    //             $image.mapster("resize", img.naturalWidth, img.naturalHeight, 0);
    //         }
    //     }, 250);
    // });
  };

  async checkVariantAvailability(variantId, limit) {
    try {
      // Fetch variant data
      const variantRes = await fetch(`/variants/${variantId}.json`);
      
      if (!variantRes.ok) {
        throw new Error(`Variant not found: ${variantRes.status}`);
      }
      
      let variantData;
      try {
        variantData = await variantRes.json();
      } catch (jsonError) {
        throw new Error(`Invalid response format: ${jsonError.message}`);
      }
      // Fetch product data
      const productRes = await this.getProductData(variantData.product_variant.product_id);
      let variantGid = `gid://shopify/ProductVariant/${parseInt(variantId, 10)}`;
      const matchingVariant = productRes.variants.edges.map(v => v.node).find(v => v.id === variantGid);
      if(!matchingVariant || matchingVariant.availableForSale == false){
        const outOfStockModal = document.getElementById('PopupModal-out-of-stock');
        if (outOfStockModal) {
          outOfStockModal.show();
        }
        return;
      }
      const firstImage = productRes.images.edges[0]?.node.src || null;
      const title = productRes.title;
      if (!cartArray.some(item => item.variant_id === variantId)) {
        cartArray.push({
          image: firstImage,
          title: title,
          variant_id: variantId,
          limit: parseInt(limit),
          quantity:1,
          product_id: productRes.id,
          variant_price: variantData.product_variant.price,
          variant_compare_at_price: variantData.product_variant.compare_at_price
        });
        this.updatePartDrawer();
      }else{
        window.notificationEle.updateNotification(
          "Part Availability",
          "Part is already in the cart!",
          { type: "error", timeout: 5000 }
        );
        return;
      };

    
      

    } catch (err) {
      console.error("Error fetching product:", err);
      window.notificationEle.updateNotification(
        "Product Not Found",
        "The requested product could not be found. Please contact support.",
        { type: "error", timeout: 10000 }
      );
    }
  }

  async getProductData(productId){

    productId = parseInt(productId); // numeric ID from variant API
    const gid = `gid://shopify/Product/${productId}`;
    const query = `
    {
      product(id: "${gid}") {
        id
        title
        handle
        availableForSale
        images(first: 1) {
          edges {
            node {
              src: url
              altText
            }
          }
        }
           variants(first: 50) {
          edges {
            node {
              id
              sku
              title
              availableForSale
              quantityAvailable
              barcode
              price {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
    `;

  let productData = await fetch(storefrontUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontToken
      },
      body: JSON.stringify({ query })
    })
    .then(res => res.json())
    .then(data =>  data.data.product)
    .catch(err => console.error(err));
    return productData;
  };

  async getMainProductData(productId){
    productId = parseInt(productId);
    const gid = `gid://shopify/Product/${productId}`;
    const query = `
    {
      product(id: "${gid}") {
        id
        title
        handle
        availableForSale
        images(first: 1) {
          edges {
            node {
              src: url
              altText
            }
          }
        }
        variants(first: 1) {
          edges {
            node {
              id
              sku
              title
              availableForSale
              quantityAvailable
              barcode
              price {
                amount
                currencyCode
              }
            }
          }
        }
        metafields(identifiers: [{namespace: "custom", key: "main_product"}]) {
          key
          value
          type
        }
      }
    }
    `;

    let productData = await fetch(storefrontUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": storefrontToken
        },
        body: JSON.stringify({ query })
      })
      .then(res => res.json())
      .then(data => data.data.product)
      .catch(err => console.error(err));
      
    return productData;
  };

  updatePartDrawer() {
    const partDrawer = document.querySelector("[data-part-cart-body]");
    
    partDrawer.innerHTML = "";
    let cartTotal = 0;
  
    cartArray.forEach((item, index) => {
      const quantity = item.quantity || 1;
      const price = parseFloat(item.variant_price); // Shopify price in dollars
      let warranty = localStorage.getItem("warranty");
      let variantPrice = item.variant_price;
      let variantCompareAtPrice = item.variant_compare_at_price;
      let itemTotal = price * quantity;
      
      if(warranty == "true" || warranty == true){
        variantPrice = 0 ;
        variantCompareAtPrice = item.variant_price ;
        itemTotal = 0; // Set item total to 0 when warranty is true
      }

      cartTotal += itemTotal;
      partDrawer.innerHTML += `
       
            <div class="cart-items" data-cart-item data-variant-id="${item.variant_id}">
              <div class="d-flex cart-item mx-0">
                <!-- Product Image -->
                <div class="pe-0 d-none">
                  <div class="cart-img">
                    <img class="img-fluid item-img" src="${item.image}" alt="${item.title}" loading="lazy" width="75" height="75">
                  </div>
                </div>
  
                <!-- Product Details -->
                <div class="w-100 d-flex flex-column">
                  <div class="cart-item-text">
                    <div class="d-flex align-items-start justify-content-between mb-3">
                      <a href="/products/${item.product_id}?variant=${item.variant_id}" class="card-title text-uppercase lh-sm fw-medium">${item.title}</a>
                      
                      <a class="my-0 d-inline-block lh-1 ms-2" href="#" title="Remove" aria-label="Remove" data-toggle="tooltip" data-item-remove data-index="${index}" data-placement="left" data-remove-item="${item.variant_id}">
                        <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" class="text-primary">
                          <use href="#icon-close-cart"></use>
                        </svg>
                      </a>
                    </div>
                  </div>
                  <!-- Quantity & Price -->
                  <div class="d-flex align-items-center justify-content-between mt-auto">
                    
                    <!-- Quantity -->
                    <div class="quantity-wrapper quantity-wrapper-sm" data-qty-container="${item.variant_id}">
                      <label class="d-none" for="Quantity_${index}" title="Quantity">Quantity</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <a href="#" class="input-group-text border-end-0 btn min-h-100" rel="nofollow" aria-label="Decrease quantity for ${item.title}" data-for="decrease" data-qty-btn>
                            <svg aria-hidden="true" focusable="false" style="width:12px;height:1px;">
                              <use href="#icon-minus"></use>
                            </svg>
                          </a>
                        </div>
                        
                        <input type="text" name="updates[]" id="updates_${item.variant_id}" aria-label="${item.title}" value="${item.quantity}" step="1" min="1" inputmode="numeric" data-qty-input data-index="${index}" class="quantity form-control fs-lg fw-light px-1 text-center border-gray-400 border-end-0 border-start-0">
                        
                        <div class="input-group-append">
                          <a href="#" class="input-group-text btn min-h-100 border-start-0" rel="nofollow" aria-label="Increase quantity for ${item.title}" data-for="increase" data-qty-btn>
                            <svg aria-hidden="true" focusable="false" style="width:12px;height:11px;">
                              <use href="#icon-plus"></use>
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>
  
                    <!-- Price -->
                    <div class="cart-total-price">
                      ${
                        variantCompareAtPrice > variantPrice
                          ? `<del class="lh-sm">$${variantCompareAtPrice}</del>
                             <span class="lh-sm m-0 p-0 text-danger ms-1">$${variantPrice}</span>`
                          : `<span class="lh-sm m-0 p-0">$${variantPrice}</span>`
                      }
                    </div>
  
                  </div>
                </div>
  
              </div>
            </div>
          
      `;
    });
    // Format the cart total to fix floating-point precision issues
    const formattedTotal = Utility.formatMoney(Math.round(cartTotal * 100), window.globalVariables.money_format);
    document.querySelector("[data-part-cart-total]").innerHTML = formattedTotal;
    this.attachQuantityHandlers();
    this.attachRemoveItemHandlers();
    if(cartArray.length > 0){
      document.querySelector("[data-part-cart-body]")?.classList.remove("d-none");
      document.querySelector("[data-part-cart-empty-message]")?.classList.add("d-none");  
      document.querySelector("[data-part-checkout-btn]")?.classList.remove("disabled");
    }else{
      document.querySelector("[data-part-cart-body]")?.classList.add("d-none");
      document.querySelector("[data-part-cart-empty-message]")?.classList.remove("d-none");
      document.querySelector("[data-part-checkout-btn]")?.classList.add("disabled");
    }
  };

  attachQuantityHandlers() {
    document.querySelectorAll("[data-for='increase']").forEach(btn => {
      btn.addEventListener("click", e => {
        e.preventDefault();
        const qtyContainer = btn.closest("[data-qty-container]");
        const variantId = qtyContainer.dataset.qtyContainer;
        let item = cartArray.find(item => item.variant_id === variantId);
        if (item.quantity < item.limit) {
          item.quantity = (item.quantity || 1) + 1;
          this.updatePartDrawer();
        }else{
          window.notificationEle.updateNotification(
            "Part Availability",
            "Part is already in the cart with max quantity",
            { type: "error", timeout: 5000 }
          );
        }
      });
    });
  
    document.querySelectorAll("[data-for='decrease']").forEach(btn => {
      btn.addEventListener("click", e => {
        e.preventDefault();
        const qtyContainer = btn.closest("[data-qty-container]");
        const variantId = qtyContainer.dataset.qtyContainer;
        let item = cartArray.find(item => item.variant_id === variantId);
  
        if (item.quantity > 1) {
          item.quantity -= 1;
          this.updatePartDrawer();
        }
      });
    });
  };

  attachRemoveItemHandlers() {
    document.querySelectorAll("[data-item-remove]").forEach(btn => {
      btn.addEventListener("click", e => {
        e.preventDefault();
        const variantId = btn.dataset.removeItem;
        cartArray = cartArray.filter(item => item.variant_id !== variantId);
        this.updatePartDrawer();
      });
    });
  };  

  async addToCart(event){
    let currentElement = event.currentTarget;
    currentElement.classList.add("loading");
    currentElement.classList.add("disabled");
    const warranty = localStorage.getItem("warranty");

      // First clear cart
  await this.clearCart();

  // Prepare items from cartArray
  // Prepare items from cartArray
  const items = cartArray.map(cartItem => {
    let item = {
      id: cartItem.variant_id,
      quantity: cartItem.quantity
    };

    // If warranty is true, add custom properties
    if (warranty == "true" || warranty == true ) {
      item.properties = {
        "_is_free_part_item": true,
        "_free_part_item_freq" : cartItem.limit
      };
    }else{
      item.properties = {
        "_free_part_item_freq" : cartItem.limit
      };
    }
    return item;
  });

  console.log(items);
   // Add items to cart
   const body = JSON.stringify({
    items: items,
    sections: `${((window.globalVariables.template == 'cart') ? 'template-cart' : 'component-cart-drawer')},header` 
  });
  
  fetch(`${routes.cart_add_url}`, { ...Utility.fetchConfig(), body })
  .then((response) => response.json())
  .then((res) => {
    let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
    if(dataJSON.errors){
      window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
        type: 'error',
        timeout: 5000
      });
      return;
    }
    if(document.querySelectorAll(".modal.open").length > 0){
      document.querySelectorAll(".modal.open").forEach(ele=>{
        ele.classList.remove("open");
        document.body.classList.remove("scroll-fixed");
      })
    }

    // Remove warranty status when proceeding to checkout
    localStorage.setItem("warranty", "false");
    
    window.location.href = '/checkout';
   
  //  if(qtyInput) qtyInput.value = 1;
    // if(cartElement && window.globalVariables.template != 'cart'){
    //   cartElement._updateCart(dataJSON.sections, 'open_drawer');
    // }else{
    //   window.location.href = window.routes.cart_fetch_url;
    // }      
  })
  .catch((e) => {
    window.notificationEle.updateNotification('Error', e, {
      type: 'error',
      timeout: 5000
    });
    console.error(e);
  })
  .finally(() => {
    currentElement.classList.remove('loading');
    currentElement.removeAttribute('disabled');
  });


  };

  scrollToCartSection() {
    // Check if we're on a mobile device (screen width <= 768px)
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      // Find the cart section
      const cartSection = document.querySelector('[data-part-cart-drawer-container]');
      
      if (cartSection) {
        // Scroll to the cart section with smooth behavior
        cartSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        
        // Add a subtle highlight effect to draw attention
        cartSection.style.transition = 'box-shadow 0.3s ease';
        cartSection.style.boxShadow = '0 0 20px rgba(0, 123, 255, 0.3)';
        
        // Remove the highlight after 2 seconds
        setTimeout(() => {
          cartSection.style.boxShadow = '';
        }, 2000);
      } else {
        console.warn('Cart section not found for scrolling');
      }
    }
  }

  async clearCart() {
    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      if (!response.ok) throw new Error(`Cart clear failed: ${response.statusText}`);
    } catch (err) {
      console.error("Error clearing cart:", err);
    }
  }

}
new BatchCodeSetup();